/* eslint-disable */
//tslint:disable

export interface IUndergroundInfoSchema {
  /** ID метро **/
  id?: number | null;
  /** Цвет линии метро, hex **/
  lineColor?: string | null;
  /** Название **/
  name?: string | null;
  /** Год сдачи для строящейся станции **/
  releaseYear?: number | null;
  /** Время в пути в минутах до метро, мин **/
  travelTime?: number | null;
  /** Способ передвижения до метро **/
  travelType?: ETravelType | null;
  /** Является ли станция строящейся **/
  underConstruction?: boolean | null;
  /** Ссылка (ЧПУ) **/
  url?: string | null;
}

export enum ETravelType {
  /** На транспорте **/
  Transport = 'transport',
  /** Пешком **/
  Walk = 'walk',
}
